import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import modalStyle from '../styles/modal';

Modal.setAppElement('#root');
class NewsItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            newsItem: '',
            index: '',
            confirm: {
                isShow: false,
                title: '',
                message: ''
            }
        }
    }

    componentDidMount() {
        this.setState({
            newsItem: this.props.newsItem,
            index: this.props.index
        });
    }

    handleEdit = () => {
        this.props.handleEdit(this.state.newsItem);
    }

    showConfirmModal = () => {
        this.setState({
            confirm: {
                isShow: true,
                title: 'Eliminar noticia',
                message: "Está seguro de eliminar esta noticia."
            }
        });
    }

    closeConfirmModal = (confirmed) => {
        this.setState({
            confirm: {
                isShow: false,
                title: '',
                message: ''
            }
        });
        if (confirmed) {

            this.props.handleDelete(this.props.newsItem);
        }
    }

    render() {
        const { newsItem, confirm } = this.state;

        return (
            <tr>
                {/* <th className="align-middle" scope="row">{index}</th> */}
                <td className="text-wrap align-middle" >{newsItem.title}</td>
                <td className="text-break align-middle" >
                    <a target="_blank" rel="noopener noreferrer" href={newsItem.url} className="card-link text-primary">
                        <FontAwesomeIcon className="mr-2" icon={faExternalLinkAlt} />
                        <small>Abrir</small>
                    </a>
                </td>
                <td className="align-middle" >
                    <div className="nav justify-content-end">
                        <button onClick={this.showConfirmModal} className="btn btn-sm btn-danger" data-toggle="tooltip" data-placement="bottom" title="Eliminar">
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </button>
                        <button onClick={this.handleEdit} className="btn btn-sm btn-info ml-2" data-toggle="tooltip" data-placement="bottom" title="Editar">
                            <FontAwesomeIcon icon={faEdit} />
                        </button>
                    </div>
                </td>

                <Modal
                    isOpen={confirm.isShow}
                    contentLabel="Modal Example"
                    style={modalStyle}
                    onRequestClose={() => this.closeConfirmModal(false)}>
                    <div className="" style={{ minWidth: '300px', maxWidth: '400px' }}>
                        <h5 className="card-title">{confirm.title}</h5>
                        <p className="card-text text-break">{confirm.message}</p>

                        <div className="nav justify-content-end">
                            <button onClick={() => this.closeConfirmModal(false)} className="btn btn-sm btn-dark">No</button>
                            <button onClick={() => this.closeConfirmModal(true)} className="btn btn-sm btn-dark ml-2 pl-2 pr-2">Si</button>
                        </div>
                    </div>

                </Modal>
            </tr>


        );
    }
}

export default NewsItem;